import {
	CaseReducer,
	createAsyncThunk,
	createSlice,
	PayloadAction,
} from '@reduxjs/toolkit';
import { STATUS } from '../globalContext/globalContext.interfaces';
import { IThunkApiExtra, RootState } from '../store';
import { FilterDepencyGetAPIType, IFilterDependecyGet, setFilterDependencyType } from '@/components/templates/filters/interfaces/IFilterData.request';
import { IFilterDataContext } from '../globalContext/filterDataContext.interface';
import { IFilterValues } from '@/components/templates/filters/interfaces/IFilterData';


type State = IFilterDataContext

export const initialState: State = {
	filtersData: [],
	status: STATUS.idle,
	message: undefined,
	cargando: false,
	error: ""
}

export const filterDataGet = createAsyncThunk<State, IFilterDependecyGet, { extra: IThunkApiExtra}>(
	'filterData/get',
	async (request: IFilterDependecyGet | undefined, thunkApi) => {
		// https://www.w3docs.com/snippets/javascript/how-to-encode-javascript-object-to-query-string.html
		// const requestAsQuery = new URLSearchParams(request as any).toString();
		const { rejectWithValue, extra } = thunkApi
		if (request === undefined) return rejectWithValue("Se necesita información para buscar datos");
		const { filterId, value } = request;
		if (filterId === undefined) return rejectWithValue("No se puede buscar sin un filtro de destino (`filterId`)");
		if (value === undefined) return rejectWithValue("No se puede buscar sin un valor (`value`)");
		const { services } = extra;
		const servicesList = (await services()).setupServices()
		// The search array service
		const searchAPI: { id: string, service: FilterDepencyGetAPIType }[] = [
			{
				id: "comuna", service: async (id: string) => (await servicesList.getComunas(+id))
					.map(comuna => ({
						label: comuna.descripcion,
						value: [comuna.idComuna],
						id: +comuna.idComuna,
					}))
			},
			{
				id: "barrio", service: async (id: string) => (await servicesList.getBarrios(+id))
					.map((barrio) => ({
						label: barrio.label,
						value: barrio.value,
						id: barrio.id,
					}))
			}
		]

		const APIFound = searchAPI.find((searchAPIEntry) => searchAPIEntry.id === filterId);
		if (APIFound === undefined)
			return rejectWithValue("No se puede buscar sin un servicio asociado (`APIFound`)");
		const { service }= APIFound;
		// const response = await fetch(`${apiEndpoint}/properties?${requestAsQuery ?? "page=1"}`)
		// Inferred return type: Promise<MyData>
		// Metodo de obtencion de propiedades anterior
		// return (await servicesList.getProperties(request)) as State
		
		return {
			message: "OK",
			filtersData: [{
				id: filterId,
				values: await service(value),
			}],
			status: STATUS.idle
		} as State
	}
)

export const FilterDataSlice = createSlice({
	name: 'filterData',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder.addCase(filterDataGet.pending, (state, action) => {
			state.status = STATUS.pending;
			state.lastRequestId = action.meta.requestId;
		})
		builder.addCase(filterDataGet.fulfilled, (state, action) => {
			const { message, filtersData } = action.payload;
			const firstDataEntry = filtersData.pop();
			state.message = message;
			state.status = message !== undefined ? STATUS.error : STATUS.idle

			if (firstDataEntry === undefined) {
				return;
			}
			const filterDataPrevValues = state.filtersData.filter(data => data.id !== firstDataEntry.id)

			state.filtersData = [ ...filterDataPrevValues, firstDataEntry]
		})
		builder.addCase(filterDataGet.rejected, (state, action) => {
			state.status = STATUS.error;
			state.message = action.error ? action.error.message: "Ha ocurrido un error";
		})
	}
})

export const selectFilterDataState = (state: RootState) => state.FilterDataState;